import * as React from "react";
import {
  List,
  DataTable,
  TextField,
  ReferenceField,
  NumberField,
  DateInput,
  AutocompleteArrayInput,
  ReferenceArrayInput,
  SelectArrayInput,
  FunctionField,
  usePermissions,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { startOfDay, addMonths, endOfDay } from "date-fns";

const ADDITIONAL_INVOICED = 1.5;

const RestaurantStatsFilter = () => {
  const { permissions } = usePermissions();
  return [
    <DateInput source="fromDate" label="Fecha Desde" alwaysOn />,
    <DateInput source="toDate" label="Fecha Hasta" alwaysOn />,
    ...(permissions === ROLE_TYPES.ADMIN
      ? [
          <ReferenceArrayInput
            source="restaurants"
            reference="restaurants"
            perPage={100}
            filter={{
              type: RESTAURANT_TYPES.REGULAR,
              active: true,
            }}
            alwaysOn
          >
            <AutocompleteArrayInput
              filterToQuery={(searchText) => ({ name: searchText })}
              label="Restaurante(s)"
              fullWidth
              optionText="name"
            />
          </ReferenceArrayInput>,
          <ReferenceArrayInput
            source="region"
            reference="regions"
            perPage={100}
            sort={{ field: "name", order: "ASC" }}
            label="Regiones"
          >
            <SelectArrayInput optionText="name" label="Regiones" />
          </ReferenceArrayInput>,
        ]
      : []),
    ...(permissions === ROLE_TYPES.ADMIN
      ? [
          <ReferenceArrayInput
            source="districts"
            reference="districts"
            perPage={10000}
            filter={{
              active: true,
            }}
            sort={{ field: "name", order: "ASC" }}
          >
            <SelectArrayInput optionText="name" label="Barrio(s)" fullWidth />
          </ReferenceArrayInput>,
        ]
      : []),
  ];
};

const RestaurantStatsList = () => {
  const { permissions } = usePermissions();
  return (
    <List
      title="Estadísticas"
      filters={RestaurantStatsFilter()}
      filterDefaultValues={{
        fromDate: addMonths(startOfDay(new Date()), -1),
        toDate: endOfDay(new Date()),
      }}
    >
      <DataTable bulkActionButtons={false}>
        {permissions === ROLE_TYPES.ADMIN && (
          <DataTable.Col source="id" label="Restaurante">
            <ReferenceField
              label="Restaurante"
              reference="restaurants"
              source="id"
              link="show"
            >
              <TextField source="name" />
            </ReferenceField>
          </DataTable.Col>
        )}
        <DataTable.Col source="redeemedCouponsCount" label="Cupones Canjeados">
          <NumberField
            source="redeemedCouponsCount"
            label="Cupones Canjeados"
          />
        </DataTable.Col>
        {permissions === ROLE_TYPES.ADMIN && (
          <DataTable.Col
            source="totalPrice"
            label="Facturado (Precio de lista)"
          >
            <NumberField
              source="totalPrice"
              label="Facturado (Precio de lista)"
              options={{
                style: "currency",
                currency: "ARS",
                currencyDisplay: "narrowSymbol",
              }}
            />
          </DataTable.Col>
        )}
        <DataTable.Col
          source="paidPrice"
          label={`${
            permissions === ROLE_TYPES.ADMIN
              ? "Facturado (Precio final)"
              : "Facturado"
          }`}
        >
          <NumberField
            source="paidPrice"
            label={`${
              permissions === ROLE_TYPES.ADMIN
                ? "Facturado (Precio final)"
                : "Facturado"
            }`}
            options={{
              style: "currency",
              currency: "ARS",
              currencyDisplay: "narrowSymbol",
            }}
          />
        </DataTable.Col>
        {permissions === ROLE_TYPES.RESTAURANT && (
          <DataTable.Col label={"Facturado + Adicional estimado"}>
            <FunctionField
              render={(record) =>
                (record.paidPrice * ADDITIONAL_INVOICED).toLocaleString(
                  "en-US",
                  {
                    style: "currency",
                    currency: "ARS",
                    currencyDisplay: "narrowSymbol",
                  }
                )
              }
              label={"Facturado + Adicional estimado"}
            />
          </DataTable.Col>
        )}
        {permissions === ROLE_TYPES.ADMIN && (
          <DataTable.Col source="totalSaved" label="Ahorrado">
            <NumberField
              source="totalSaved"
              label="Ahorrado"
              options={{
                style: "currency",
                currency: "ARS",
                currencyDisplay: "narrowSymbol",
              }}
            />
          </DataTable.Col>
        )}
        <DataTable.Col source="districtId" label="Barrio">
          <ReferenceField
            source="districtId"
            reference="districts"
            link={false}
            label="Barrio"
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
      </DataTable>
    </List>
  );
};

export default RestaurantStatsList;
